<template>
    <div class="fax-template-field">
        <div v-if="faxTypes.length === 0" class="text-center text-muted py-3">
            <i class="fas fa-spinner fa-spin"></i> Loading fax templates...
        </div>
        <div v-else class="template-grid">
            <FaxTemplateUploadControl
                v-for="faxType in faxTypes"
                :key="faxType.value"
                :fax-type="faxType.name"
                :fax-type-name="faxType.name"
                :value="getValue(faxType.name)"
                @input="updateValue(faxType.name, $event)"
            />
        </div>
    </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import axios from 'axios';
import FaxTemplateUploadControl from '@/components/Configuration/FaxTemplateUploadControl.vue';
import { NotificationOptions } from '@/util/NotificationOptionsPresets';

interface FaxTemplateOverride {
    imageId: number;
    fileName?: string;
}

@Component({
    name: 'FaxTemplateField',
    components: {
        FaxTemplateUploadControl,
    },
})
export default class FaxTemplateField extends Vue {
    @Prop({ default: () => ({}) })
    readonly value!: Record<string, FaxTemplateOverride>;

    private faxTypes: Array<{value: string, name: string}> = [];

    mounted() {
        this.loadFaxTypes();
    }

    private async loadFaxTypes() {
        try {
            const response = await axios.get('/api/Fax/template-types');
            this.faxTypes = response.data;
        } catch (error) {
            console.error('Error loading fax types:', error);
            this.$notification(NotificationOptions.error('Failed to load fax template types'));
        }
    }

    private getValue(faxType: string): FaxTemplateOverride | null {
        return this.value?.[faxType] || null;
    }

    private updateValue(faxType: string, newValue: FaxTemplateOverride | null) {
        const updatedValue = { ...this.value };

        if (newValue === null) {
            // Remove the override
            delete updatedValue[faxType];
        } else {
            // Add or update the override
            updatedValue[faxType] = newValue;
        }

        this.$emit('input', updatedValue);
    }
}
</script>

<style scoped>
.fax-template-field {
    width: 100%;
}

.template-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(min(100%, 350px), 1fr));
    gap: 15px;
    margin-top: 10px;
}

@media screen and (min-width: 1200px) {
    .template-grid {
        grid-template-columns: repeat(3, 1fr);
    }
}
</style>
